/**
 * ClickableBarcode - Wrapper that makes any barcode clickable to open a zoom modal
 */
import React, { useState } from 'react';
import { BarcodeZoomModal } from './BarcodeZoomModal';

interface ClickableBarcodeProps {
  children: React.ReactNode;
  productName?: string;
}

export const ClickableBarcode: React.FC<ClickableBarcodeProps> = ({
  children,
  productName,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
        className="cursor-pointer hover:opacity-75 transition-opacity inline-block"
        title="Clique para ampliar"
      >
        {children}
      </div>
      {isOpen && (
        <BarcodeZoomModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          productName={productName}
        >
          {children}
        </BarcodeZoomModal>
      )}
    </>
  );
};
